// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__8kUg8","loader":"Loader_loader__BPfBL","white":"Loader_white__gRc62"};